import React__default from 'react';
import clsx from 'clsx';
import StyledNoResult, { classes } from './index.styled.js';

var NoResult = function NoResult(_a) {
    var children = _a.children, className = _a.className, style = _a.style, sx = _a.sx, _b = _a.testId, testId = _b === void 0 ? "NoResult" : _b;
    return (React__default.createElement(StyledNoResult, { className: clsx("NoResult", className, classes.container), sx: sx, style: style, "data-testid": testId }, children));
};

export { NoResult as default };
//# sourceMappingURL=index.js.map
